import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { SubscriptionModel } from '@data-layer/models/common';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsRepository {
  constructor(private apiService: ApiService) {}

  public getSubscriptions(): Observable<SubscriptionModel[]> {
    return this.apiService.get(`${environment.url.prefixCustoms}v2/subscriptions`, null, { isShowLoader: false });
  }
}
